export default {
   /* eslint-disable key-spacing */
   '00': 'Pusat',
   '01': 'Provinsi',
   '02': 'Kabupaten/Kota',

   /* eslint-enable key-spacing */
}
